import React, { useEffect, useState, useLayoutEffect } from "react";
import axios from "axios";
import "./LayerLegend.css";
import { faBars, faListUl, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const LayerLegend = ({
  activeLayers,
  layersThatWereSwitchedNames,
  clearLayersWasClicked,
  setClearLayersWasClicked,
}) => {
  const host = process.env.REACT_APP_HOST;
  const [images, setImages] = useState({});
  const [legendIsBig, setLegendIsBig] = useState(true);
  const [legendBlobs, setLegendBlobs] = useState({});

  useLayoutEffect(() => {
    console.log("Active layers to legend:", activeLayers);

    if (activeLayers && activeLayers.length > 0) {
      console.log("bike sto active layers greater than 0");

      const newLegendBlobs = {};

      const fetchPromises = activeLayers.map((layerName) =>
        fetchLegend(layerName).then((legendBlob) => {
          if (!legendBlobs[layerName]) {
            newLegendBlobs[layerName] = legendBlob;
          }
        })
      );

      Promise.all(fetchPromises)
        .then(() => {
          console.log("All legends fetched successfully");
          setLegendBlobs((prevLegendBlobs) => ({
            ...prevLegendBlobs,
            ...newLegendBlobs,
          }));
        })
        .catch((error) => {
          console.error("Error fetching legends:", error);
        });
    } else {
      setLegendBlobs({});
      console.log("bikeedw");
    }
    console.log(legendBlobs, "legendBlobs");
  }, [activeLayers]);

  // console.log("Active layers sto legend prin to use effect:", activeLayers);
  // console.log(layersThatWereSwitchedNames);
  /**
   * This function uses the special method to call the images acosiated with the layers active
   * @param {*} layerName
   * @returns
   */
  const fetchLegend = async (layerName) => {
    const url = `${host}/getLegend/legend/${layerName}?transparent=true`;
    try {
      const response = await axios.get(url, { responseType: "blob" });
      const imgURL = (window.URL || window.webkitURL).createObjectURL(
        new Blob([response.data])
      );

      setImages((prevImages) => ({
        ...prevImages,
        [layerName]: imgURL,
      }));

      return imgURL;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };
  //this use effect activates when the activa layers change and makes sure the layers are correct and fetches all promises
  // useEffect(() => {
  //   // if (clearLayersWasClicked) {
  //   //   activeLayers = [];
  //   //   setClearLayersWasClicked(false);
  //   //   layersThatWereSwitchedNames = [];
  //   //   console.log(layersThatWereSwitchedNames, "layersThatWereSwitchedNames");
  //   // }
  //   console.log("Active layers sto legend:", activeLayers);
  //   console.log(images, "images");
  //   if (activeLayers && activeLayers.length > 0) {
  //     console.log("bike sto activbe layers greater than 0");
  //     const fetchPromises = activeLayers.map((layerName) =>
  //       fetchLegend(layerName)
  //     );

  //     Promise.all(fetchPromises)
  //       .then((results) => {
  //         console.log("All legends fetched successfully");
  //         console.log(results);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching legends:", error);
  //       });
  //   } else {
  //     setImages({});
  //     console.log("bikeedw");
  //   }
  // }, [activeLayers]);
  // console.log(JSON.stringify(activeLayers));
  useEffect(() => {
    activeLayers = [];
    setClearLayersWasClicked(false);
    layersThatWereSwitchedNames = [];
    console.log(layersThatWereSwitchedNames, "layersThatWereSwitchedNames");
  }, [clearLayersWasClicked]);

  // useEffect(() => {
  //   // Fetch legend images when activeLayers prop changes
  //   const fetchLegendImages = async () => {
  //     // Get the list of active layers
  //     const activeLegends = Object.entries(activeLayers)
  //       .filter(([layer, values]) => values.active && values.ogc === "wms")
  //       .map(([layer, values]) => {
  //         return { name: layer, title: values.title };
  //       });

  //     // Fetch legend images for each active layer
  //     const legendsBlobs = await Promise.all(
  //       activeLegends.map(async (layer) => {
  //         const Title = layer.title.split(":").pop();
  //         const blob = await fetchLegendImage(layer.name);

  //         return { title: Title, blob: blob };
  //       })
  //     );

  //     // Set the state with fetched legend blobs
  //     setActiveLegendsBlobs(legendsBlobs);
  //   };

  //   fetchLegendImages();
  // }, [activeLayers]);
  return (
    <>
      {legendIsBig && (
        <div className="layer-legend-container">
          <div className="layer-legend-title">
            <div className="left-side-title-legend">
              <FontAwesomeIcon icon={faListUl} /> Legend
            </div>
            <div
              className="close-legend-button"
              onClick={() => setLegendIsBig(false)}
            >
              <FontAwesomeIcon icon={faXmark} />{" "}
            </div>
          </div>

          <div className="layer-legend">
            {activeLayers.map((layerName, index) => {
              // console.log(activeLayers, "activeLayers mesa sto HTML");
              const imgURL = images[layerName];
              return (
                <div
                  className="layer-legend-Individual"
                  id={`${layerName}`}
                  key={index}
                >
                  <div className="legend-name">
                    {layersThatWereSwitchedNames[index]}
                  </div>
                  <div id={`${layerName}`}>
                    <img src={imgURL} alt={`Legend ${index}`} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {!legendIsBig && (
        <div
          className="layer-legend-small"
          onClick={() => setLegendIsBig(true)}
        >
          <FontAwesomeIcon icon={faBars} />
        </div>
      )}
    </>
  );
};

export default LayerLegend;
